export default __webpack_public_path__ + "static/media/Hahnekamp.09fd6a66.png";